import { UserEvents, trackEvent } from "@punchup/analytics";
import { logException, logMessage } from "@punchup/sentry";

import { Database } from "@punchup/data/supabase.types";
import { SupabaseClient } from "@supabase/supabase-js";

export interface AttendanceData {
  showId: string;
  venueId: string;
  comedianId: string;
}

export const recordAttendance = async (
  supabase: SupabaseClient<Database>,
  userId: string,
  showId: string,
  comedianId: string,
  venueId: string
) => {
  try {
    const { error: insertError } = await supabase
      .from("user_shows_attended")
      .insert({
        user_id: userId,
        comedian_id: comedianId,
        show_id: showId,
        venue_id: venueId,
      })
      .select()
      .single();

    if (insertError) {
      if (insertError.code === "23505") {
        // Unique violation.  We don't want a user to be able to add multiple records so there's a unique
        // constraint on the user_shows_attended table on user_id and show_id.  This logs a message when this happens.
        logMessage(
          `Duplicate attendance record: User ${userId} already recorded for show ${showId}`
        );
        return false;
      }
      logException(
        new Error(`Error recording attendance: ${insertError.message}`)
      );
      return false;
    }

    // Track successful attendance record
    trackEvent(UserEvents.SHOW_ATTENDANCE_RECORDED, {
      showId,
      venueId,
      comedianId,
      userId,
    });

    return true;
  } catch (error) {
    logException(error);
    return false;
  }
};
